"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const layout_1 = require("../../layout");
const base_input_1 = require("./base_input");
const label_1 = __importDefault(require("../../typography/label"));
const styled_1 = __importDefault(require("../../../styles/styled"));
const theme_1 = require("../../../styles/theme");
const Container = styled_1.default.div({
    width: '100%',
    ':focus-within': theme_1.focus.shadow,
});
const BasicInput = (_a) => {
    var { name, hideLabel } = _a, rest = __rest(_a, ["name", "hideLabel"]);
    return ((0, jsx_runtime_1.jsxs)(layout_1.Column, Object.assign({ flex: "1", alignItems: "flex-start" }, { children: [(0, jsx_runtime_1.jsx)(label_1.default, Object.assign({ bold: true, capitalize: true, htmlFor: name, screenReaderOnly: hideLabel }, { children: name })), (0, jsx_runtime_1.jsx)(Container, { children: (0, jsx_runtime_1.jsx)(base_input_1.BaseInput, Object.assign({ id: name, borderRadius: "2px", name: name, py: 2, px: 3, fontSize: 1 }, rest)) })] })));
};
exports.BasicInput = BasicInput;
//# sourceMappingURL=basic_input.js.map